import { Check, Minus } from "lucide-react";
import { Checkbox as C } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
export function Checkbox({ className, checked, ...props }: ComponentProps<typeof C.Root>) {
  return (
    <C.Root
      {...props}
      {...(checked === undefined ? {} : { checked })}
      data-slot="checkbox"
      className={cn("cyra-checkbox", className)}
    >
      <C.Indicator>
        {checked === "indeterminate" ? <Minus aria-hidden /> : <Check aria-hidden />}
      </C.Indicator>
    </C.Root>
  );
}
